import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var BatchPart = /*#__PURE__*/function () {
  function BatchPart() {
    _classCallCheck(this, BatchPart);
    this.reset();
  }
  _createClass(BatchPart, [{
    key: "begin",
    value: function begin(style, startIndex, attribStart) {
      this.reset();
      this.style = style;
      this.start = startIndex;
      this.attribStart = attribStart;
    }
  }, {
    key: "end",
    value: function end(endIndex, endAttrib) {
      this.attribSize = endAttrib - this.attribStart;
      this.size = endIndex - this.start;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.style = null;
      this.size = 0;
      this.start = 0;
      this.attribStart = 0;
      this.attribSize = 0;
    }
  }]);
  return BatchPart;
}();
export { BatchPart };